var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaintbrush(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500.36 744.09",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-276 -308.27)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m350.58 393.72 14.793 213.36h325.47l14.793-211.71c-34.846 11.573-79.614-27.739-119.82-26.286-42.986 1.5529-88.868 25.742-130.19 32.887-37.731 6.5246-71.164-3.6367-105.04-8.2551z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.38 624.83v10.375h325.47v-10.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.38 638.14v48.844l89.831 48.112c40.208 15.177 35.053 30.224 37.101 70.234l7.6206 148.81c2.9744 57.568 58.672 52.971 57.641-0.10944l6.8523-151.64c-1.8586-40.012 0.22442-46.35 33.146-63.983l93.276-49.957v-50.312z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.58825 0 0 .58825 491.83 459.15)",
    d: "m84.259 378.99a25.148 25.148 0 1 1 0.0067-0.0983"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintbrush);
export default __webpack_public_path__ + "static/media/paintbrush.68691714e3c4ef05c69018507d589dbb.svg";
export { ForwardRef as ReactComponent };